import CardItem from 'components/account/paymentMethods/CardItem';
import CompanyBenefitItem from 'components/account/paymentMethods/CompanyBenefitItem';
import { ExternalPaymentWrapper } from 'hooks/useExternalPaymentMethods';
import styled from 'styled-components/native';
import {
  Card,
  CompanyBenefit,
  Maybe,
  PaymentOption,
} from 'types/generatedSchemaTypes';
import {
  isCard,
  isCompanyBenefit,
  isCorporateAccountPaymentOption,
  isWalletToken,
} from 'utils/paymentUtils';
import CorporateAccountPaymentOptionItem from './CorporateAccountPaymentOptionItem';
import ExternalPaymentItem from './ExternalPaymentItem';
import WalletTokenItem from './WalletTokenItem';

const TitleWrapper = styled.View`
  flex-direction: row;
`;

//"Abstract" class to choose corresponding Item with correct data
const PaymentMethodItem = ({
  item,
  indexValue,
}: {
  item:
    | Maybe<Card>
    | Maybe<CompanyBenefit>
    | ExternalPaymentWrapper
    | PaymentOption;
  indexValue: number;
}) => {
  if (isCard(item)) {
    return <CardItem item={item} indexValue={indexValue} />;
  } else if (isCompanyBenefit(item)) {
    return CompanyBenefitItem({ item, indexValue });
  } else if (isCorporateAccountPaymentOption(item)) {
    return CorporateAccountPaymentOptionItem({
      item: item as PaymentOption,
      indexValue,
    });
  } else if (isWalletToken(item)) {
    return WalletTokenItem({ item: item as PaymentOption, indexValue });
  } else if (item) {
    return ExternalPaymentItem({
      item: item as ExternalPaymentWrapper,
      indexValue,
    });
  }
  return <></>;
};

export default PaymentMethodItem;
export { TitleWrapper };
